import React, { type ReactNode } from 'react';
import queryString from 'query-string';
import { getCachedFilters } from '@atlassian/jira-filters-storage';
import type { Actions } from '@atlassian/jira-software-backlog-filters-store/src/controllers/filters/actions/types.tsx';
import { FiltersStore } from '@atlassian/jira-software-backlog-filters-store/src/controllers/filters/main.tsx';
import { createContainer } from '@atlassian/react-sweet-state';
import { storeId } from '../../common/constants';
import type { State, Filters } from '../../common/types';
import { getFiltersFromQuery } from '../../common/utils/parsing';
import { setFilters } from '../filters/actions/set-filters';
import { SyncWithRouting } from '../sync-with-routing';

const Container = createContainer<
	State,
	Actions,
	{
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		onFiltersChange: (filters: Filters) => any;
		isVersionsFeatureEnabled: boolean;
		isCompanyManaged: boolean;
		boardId: number;
	}
>(FiltersStore, {
	onInit:
		() =>
		({ dispatch }, { isVersionsFeatureEnabled, isCompanyManaged, boardId }) => {
			// set initial filters from URL
			const { search } = window.location;
			const queryParams = queryString.parse(search);
			let initialFilters = getFiltersFromQuery(queryParams, isVersionsFeatureEnabled);

			if (isCompanyManaged && Object.entries(initialFilters).length === 0) {
				initialFilters = getCachedFilters('backlog', boardId) ?? {};
			}

			dispatch(setFilters(initialFilters));
		},
});

type Props = {
	isVersionsFeatureEnabled: boolean;
	boardId: number;
	children: ReactNode;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	onFiltersChange: (arg1: Filters) => any;
	isCompanyManaged: boolean;
};

export const FiltersContainer = ({
	boardId,
	onFiltersChange,
	children,
	isVersionsFeatureEnabled,
	isCompanyManaged,
}: Props) => (
	<Container
		scope={`${storeId}-${String(boardId)}`}
		onFiltersChange={onFiltersChange}
		isVersionsFeatureEnabled={isVersionsFeatureEnabled}
		isCompanyManaged={isCompanyManaged}
		boardId={boardId}
	>
		<>
			{children}
			<SyncWithRouting isVersionsFeatureEnabled={isVersionsFeatureEnabled} />
		</>
	</Container>
);
